import "./Home.module.css";
import TopNavigation from "@/reusable_sections/Header";
import TheTechnologicalFutureOfYourBusiness from "./sections/TheTechnologicalFutureOfYourBusiness";
import OurSecurityGuarantee from "./sections/OurSecurityGuarantee";
import KitchenFavorites from "./sections/KitchenFavorites";
import OurImmediateServices from "./sections/OurImmediateServices";
import NursingLocationsGrid from "./sections/NursingLocationsGrid";
import WhatElseIsWorthKnowing from "./sections/WhatElseIsWorthKnowing";
import OnlineAppointmentBooking from "./sections/OnlineAppointmentBooking";
import Faq from "./sections/Faq";
import InformationAndRights from "@/reusable_sections/Footer";
import WhyChooseUs from "./sections/WhyChooseUs";
export default function HomePage() {
  return <div>
      <TopNavigation />
      <TheTechnologicalFutureOfYourBusiness />
      <WhyChooseUs />
      <OurSecurityGuarantee />
      <KitchenFavorites />
      <OurImmediateServices />
      <NursingLocationsGrid />
      <WhatElseIsWorthKnowing />
      <OnlineAppointmentBooking />
      <Faq />
      <InformationAndRights />
    </div>;
}